import { render, staticRenderFns } from "./QrCodeAdd.vue?vue&type=template&id=456bafe2&"
import script from "./QrCodeAdd.vue?vue&type=script&lang=js&"
export * from "./QrCodeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports